import {useLayoutStore} from "@/store/layout"

export const $getCurrentModule = () => {
    const module = useLayoutStore().currentModule
    return module ? appModules[module] as AppModule : null
}

export const $getModuleIcon = (module?: string): string | null => {
    if (!module) return $getCurrentModule()?.icon ?? null
    return appModules[module]?.icon ?? null
}

export const $getModuleColor = (module: string | null = null): string | null => {
    if (!module) return $getCurrentModule()?.color ?? $getCurrentModule()?.name ?? null
    return appModules[module]?.color ?? module
}

export const appModules: AppModules = {
    dashboard: {
        name: 'dashboard',
        icon: 'home',
        color: 'app'
    },
    organisations: {
        name: 'organisations',
        icon: 'building-office',
        search: {
            detail: 'service-organisations-id-organisationBaseData'
        },
    },
    users: {
        name: 'users',
        icon: 'users',
        search: {
            nameProp: 'fullname',
            detail: 'service-users-id-userBaseData'
        },
    },
    contactPersons: {
        name: 'contactPersons',
        icon: 'contactPersons',
        search: true,
    },
    persons: {
        name: 'persons',
        icon: 'persons',
        search: true,
    },
    sportsManagement: {
        name: 'sportsManagement',
        icon: 'clipboard',
    },
    gameDays: {
        name: 'gameDays',
        icon: 'clipboard',
        search: true
    },
    basicData: {
        name: 'basicData',
        icon: 'cog',
    },
    venues: {
        name: 'venues',
        icon: 'venues',
        search: {
            detail: 'service-basicData-venues-id-venueBaseData'
        },
    },
    website: {
        name: 'website',
        icon: 'globe',
    }
}
